import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3d074193&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "../node_modules/@grapecity/activereports/styles/ar-js-ui.css?vue&type=style&index=0&lang=css&"
import style1 from "../node_modules/@grapecity/activereports/styles/ar-js-designer.css?vue&type=style&index=1&lang=css&"
import style2 from "./App.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
